import { render, staticRenderFns } from "./QuickAddLead.vue?vue&type=template&id=0baf3cf3"
import script from "./QuickAddLead.vue?vue&type=script&lang=js"
export * from "./QuickAddLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports